import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "controls",
    "modifyForm",
    "removeForm",
    "modificationSummary",
    "removalSummary",
    "modifiedFlag",
    "removedFlag"
  ];

  connect() {
    console.log("Supervisor Rating Modifier controller connected");
  }

  showModifyForm() {
    this.hideAllForms();
    this.modifyFormTarget.style.display = "block";
    this.controlsTarget.style.display = "none";
  }

  showRemoveForm() {
    this.hideAllForms();
    this.removeFormTarget.style.display = "block";
    this.controlsTarget.style.display = "none";
  }

  applyModification(event) {
    event.preventDefault();
    
    const ratingSelect = this.modifyFormTarget.querySelector('select[name*="supervisor_rating_value"]');
    const reasonTextarea = this.modifyFormTarget.querySelector('textarea[name*="supervisor_change_reason"]');
    
    if (!ratingSelect.value) {
      alert("Please select a rating");
      return;
    }
    
    if (!reasonTextarea.value || reasonTextarea.value.trim() === "") {
      alert("Please provide a reason for changing the rating");
      return;
    }
    
    // Set the modified flag
    this.modifiedFlagTarget.value = "true";
    
    // Hide form and show summary
    this.modifyFormTarget.style.display = "none";
    this.modificationSummaryTarget.style.display = "block";
    
    console.log("Rating modified:", ratingSelect.value, "Reason:", reasonTextarea.value);
  }

  applyRemoval(event) {
    event.preventDefault();
    
    const reasonTextarea = this.removeFormTarget.querySelector('textarea[name*="supervisor_removal_reason"]');
    
    if (!reasonTextarea.value || reasonTextarea.value.trim() === "") {
      alert("Please provide a reason for removing this competency");
      return;
    }
    
    // Set the removed flag
    this.removedFlagTarget.value = "true";
    
    // Hide form and show summary
    this.removeFormTarget.style.display = "none";
    this.removalSummaryTarget.style.display = "block";
    
    console.log("Competency removed. Reason:", reasonTextarea.value);
  }

  cancelModification() {
    this.hideAllForms();
    this.controlsTarget.style.display = "block";
    
    // Reset form
    const ratingSelect = this.modifyFormTarget.querySelector('select[name*="supervisor_rating_value"]');
    const reasonTextarea = this.modifyFormTarget.querySelector('textarea[name*="supervisor_change_reason"]');
    if (ratingSelect) ratingSelect.value = "";
    if (reasonTextarea) reasonTextarea.value = "";
  }

  cancelRemoval() {
    this.hideAllForms();
    this.controlsTarget.style.display = "block";
    
    // Reset form
    const reasonTextarea = this.removeFormTarget.querySelector('textarea[name*="supervisor_removal_reason"]');
    if (reasonTextarea) reasonTextarea.value = "";
  }

  hideAllForms() {
    if (this.hasModifyFormTarget) this.modifyFormTarget.style.display = "none";
    if (this.hasRemoveFormTarget) this.removeFormTarget.style.display = "none";
    if (this.hasModificationSummaryTarget) this.modificationSummaryTarget.style.display = "none";
    if (this.hasRemovalSummaryTarget) this.removalSummaryTarget.style.display = "none";
  }
}

